import ApiEndpoints from '@/config/ApiEndpoints';
import { prepareUrl } from '@/helpers/UrlHelpers';
import ApiService from '@/services/ApiService';

export default class FetchAllUserAddresses {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * FetchAllUserAddresses constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Get all the user's addresses.
     *
     * @param {number} userId
     *
     * @returns {Promise}
     */
    handle(userId) {
        let apiUrl = prepareUrl(ApiEndpoints['addresses.index'], [userId]);

        return this.apiService.get(apiUrl);
    }
}
